// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"771b9438","431":"8569ec47","977":"1d84c21d"}[chunkId] + ".css";
};